import "./css/N0llehandboken.css";

function N0llehandboken() {
    return (
        <section className="handbook">
            <iframe
                src="/N0llehandboken.pdf"
                title="N0llehandboken"
            />
        </section>
    );
}

export default N0llehandboken;